<!--  -->
<template>
    <div class='details'>
        <div class="details_box">
            <div class="title">
                {{ data.title }}
            </div>
            <div class="content" v-html="data.content"></div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: 'details',
        data() {
            //这里存放数据
            return {
                code:null,
                data:{},
            }
        },
        components: {},

        //方法集合
        methods: {
            artinfo() {
                var _this = this;
                _this.$api.artinfo({
                    code:_this.code
                }).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        this.data=res.data
                       
                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
        },
        created() {

        },
        mounted() {
            if (this.$route.params.code) {
                this.code = this.$route.params.code;
                console.log(this.code)
                this.artinfo()
            }
        }
    }
</script>
<style scoped>

</style>